import React, { useContext, useReducer, useMemo, createContext } from 'react'

import reducers from './reducers'

export const StoreContext = React.createContext([])

export const LayoutContext = React.createContext({})

export const ProductContext = React.createContext({})

export const SettingsContext = React.createContext({})

const initialState = {
  cartOpen: false,
  searchOpen: false,
  asideOpen: false,
  sizeWizardOpen: false,
  nodeLocale: 'nl',
}

export const UIContext = createContext(initialState)

export const UIProvider = (props) => {
  const [state, dispatch] = useReducer(reducers, initialState)

  const setCartOpen = (open) =>
    dispatch({ type: `${open ? 'OPEN' : 'CLOSE'}_CART` })

  const setSearchOpen = (open) =>
    dispatch({ type: `${open ? 'OPEN' : 'CLOSE'}_SEARCH` })

  const setSizeWizardOpen = (open) =>
    dispatch({ type: `${open ? 'OPEN' : 'CLOSE'}_SIZE_WIZARD` })

  const setAsideOpen = (open) =>
    dispatch({ type: `${open ? 'OPEN' : 'CLOSE'}_ASIDE` })

  const setNodeLocale = (data) => dispatch({ type: 'SET_NODE_LOCALE', data })

  const value = useMemo(
    () => ({
      ...state,
      setCartOpen,
      setSearchOpen,
      setSizeWizardOpen,
      setNodeLocale,
      setAsideOpen,
    }),
    [state],
  )

  return <UIContext.Provider value={value} {...props} />
}

export const useUI = () => {
  const context = useContext(UIContext)

  if (context === undefined) {
    throw new Error(`useUI must be used within a UIProvider`)
  }

  return context
}
